// extracted by mini-css-extract-plugin
module.exports = {"tree":"DocsCategoryTree-module--tree--3_vLf"};